export const infinteScrollEndMessage = () => {
    return (
        <p className="infinite-end-message" style={{ textAlign: 'center', color: 'white', fontSize: '12px' }}>
            <b>Yay! You have seen it all</b>
        </p>
    )
}